import script from "./UserInput.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInput.vue?vue&type=script&setup=true&lang=js"

import "./UserInput.vue?vue&type=style&index=0&id=4e96d076&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e96d076"]])

export default __exports__